import React from 'react';
import PropTypes from 'prop-types';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { PurchaseMethods, CurrencyFormats } from '@sm360/widget-commons-vehicle';
import 'payment-calculator/components/TaxesIncluded/taxesIncluded.scss';

const TaxesIncluded = ({ purchaseMethods }) => {
    const taxCodes = purchaseMethods.getTaxCodesString();
    const selectedFinanceTerm = purchaseMethods.getSelectedFinanceTerm();

    let calculatedPaymentBeforeTaxes;
    let calculatedPaymentTaxes;
    let calculatedPayment;
    if (selectedFinanceTerm) {
        const calculatedPayments = selectedFinanceTerm.getCalculatedPayments(false);
        calculatedPaymentBeforeTaxes = calculatedPayments.calculatedPaymentBeforeTaxes;
        calculatedPaymentTaxes = calculatedPayments.calculatedPaymentTaxes;
        calculatedPayment = calculatedPayments.calculatedPayment;
    }

    const calculatedFormattedPayments = {
        calculatedPaymentBeforeTaxes:
            calculatedPaymentBeforeTaxes > 0
                ? LocaleService.l(calculatedPaymentBeforeTaxes, CurrencyFormats.CURRENCY_2)
                : '',
        calculatedPaymentTaxes:
            calculatedPaymentBeforeTaxes > 0 ? LocaleService.l(calculatedPaymentTaxes, CurrencyFormats.CURRENCY_2) : '',
        calculatedPayment:
            calculatedPaymentBeforeTaxes > 0 ? LocaleService.l(calculatedPayment, CurrencyFormats.CURRENCY_2) : '',
    };
    const paymentTaxesDisclaimer =
        ` + ${calculatedFormattedPayments.calculatedPaymentTaxes} (${taxCodes})` +
        ` = ${calculatedFormattedPayments.calculatedPayment}`;

    return (
        <section className="taxesIncluded-section is-light">
            {calculatedFormattedPayments.calculatedPaymentBeforeTaxes && (
                <label htmlFor="taxesSlide" className="payment-detail is-light">
                    <span className="is-util">{calculatedFormattedPayments.calculatedPaymentBeforeTaxes}</span>
                    <span>{paymentTaxesDisclaimer}</span>
                </label>
            )}
        </section>
    );
};

TaxesIncluded.propTypes = {
    purchaseMethods: PropTypes.instanceOf(PurchaseMethods.PurchaseMethodsModel),
};

TaxesIncluded.displayName = 'TaxesIncluded';

export default TaxesIncluded;



// WEBPACK FOOTER //
// ./src/components/TaxesIncluded/TaxesIncluded.jsx